import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import {
  SmsRichCampainStatistic,
  SmsRichPeriodStatistic,
  // SmsRichPeriodStatistic,
  SmsRichPeriodStatistics,
  SmsRichUserStatistic
} from '@models/sms/rich-sms-details';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RichSmsDetailsService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getSmsRichPeriodStatistics(uuid: string): Observable<SmsRichPeriodStatistics> {
    return this.http.get<SmsRichPeriodStatistics>(this.baseUrl + '/sms/rich/timeline/' + uuid).pipe(
      map(data => {
        return SmsRichPeriodStatistics.deserialize({
          data: (data && (data as any) ? ((data as any) as Array<string>) : []).map(data2 => SmsRichPeriodStatistic.deserialize(data2)),
          total: (data as any).length
        });
      })
    );
  }

  getSmsRichCampainStatistics(uuid: string): Observable<SmsRichCampainStatistic> {
    return this.http.get<SmsRichCampainStatistic>(this.baseUrl + '/sms/rich/aggregate/' + uuid, {});
    // .pipe(
    //   map(data => {
    //     return SmsRichCampainStatistics.deserialize({
    //       data: (data && (data as any) ? ((data as any) as Array<string>) : []).map(data2 => SmsRichCampainStatistic.deserialize(data2)),
    //       total: (data as any).length
    //     });
    //   })
    // );
  }

  getSmsRichUserStatistics(uuid: string): Observable<SmsRichUserStatistic> {
    return this.http.get<SmsRichUserStatistic>(this.baseUrl + '/sms/rich/clicks-summary/' + uuid, {});
    // .pipe(
    //   map(data => {
    //     return SmsRichUserStatistics.deserialize({
    //       data: (data && (data as any) ? ((data as any) as Array<string>) : []).map(data2 => SmsRichUserStatistic.deserialize(data2)),
    //       total: (data as any).length
    //     });
    //   })
    // );
  }

  exportHistorySmsStatuses(from, to, email?, format?): Observable<any> {
    let params = new HttpParams();
    params = params.append('from', from);
    params = params.append('to', to);

    if (email) {
      params = params.append('email', email);
    }

    if (format) {
      params = params.append('format', format);
    }
    return this.http.post(this.baseUrl + 'subaccount/history/sent-sms-details', {
      params,
      responseType: 'text' as 'json'
    });
  }
}
